import * as React from "react";

import type { ExcelBrandDefaults } from "../branding/excelBrandDefaults";

interface ExcelBrandDefaultsToggleProps {
  activeBrand: ExcelBrandDefaults;
  enabled: boolean;
  onToggle: () => void;
}

export const ExcelBrandDefaultsToggle: React.FC<
  ExcelBrandDefaultsToggleProps
> = ({ activeBrand, enabled, onToggle }) => (
  <div className="mb-1.5 flex items-center">
    <button
      type="button"
      aria-pressed={enabled}
      onClick={onToggle}
      style={
        enabled
          ? {
              color: activeBrand.accentColorHex,
              backgroundColor: `${activeBrand.accentColorHex}14`,
              boxShadow: `inset 0 0 0 1px ${activeBrand.accentColorHex}33`,
            }
          : undefined
      }
      className={`group inline-flex h-7 cursor-pointer items-center gap-2 rounded-lg px-2.5 text-[11px] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-ring-focus focus-visible:ring-offset-2 ${
        enabled
          ? "shadow-sm"
          : "text-muted-foreground hover:bg-accent/60 hover:text-foreground"
      }`}
    >
      <span
        className={`relative inline-flex h-3.5 w-7 items-center rounded-full transition-colors ${
          enabled ? "" : "bg-muted-foreground/25"
        }`}
        style={
          enabled
            ? { backgroundColor: activeBrand.accentColorHex }
            : undefined
        }
      >
        <span
          className={`absolute h-2.5 w-2.5 rounded-full bg-white shadow-sm transition-transform ${
            enabled ? "translate-x-3.5" : "translate-x-0.5"
          }`}
        />
      </span>
      <span className="font-medium">{activeBrand.toggleLabel}</span>
    </button>
  </div>
);
